<script>
import { mapActions, mapState } from 'vuex';
import ReviewCard from '../components/review/ReviewCard';
import ReviewFilter from './../components/review/ReviewFilter';
import ReviewBulkButtons from '../components/review/ReviewBulkButtons';
import ReviewApprovalStatusOverview from '../components/review/ReviewApprovalStatusOverview';

export default {
  name: 'Review',
  components: {
    ReviewCard,
    ReviewFilter,
    ReviewBulkButtons,
    ReviewApprovalStatusOverview,
  },
  data: () => ({
    fab: false,
  }),
  methods: {
    ...mapActions({
      fetchReviews: 'review/fetchReviews',
    }),
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  computed: {
    ...mapState({
      reviewsLoading: state => state.review.approval.loading,
      reviewsHasMore: state => state.review.approval.items.hasMore,
      reviews: state => state.review.approval.items.reviews,
      error: state => state.review.approval.error,
      approvalError: state => state.review.approval.approvalError,
      reviewIds: state => state.review.bulk.reviewIds,
      approvalStatusFilter: state => state.review.overview.approvalStatusFilter,
    }),
  },
};
</script>

<template>
  <v-container fluid grid-list-xl>
    <v-layout>
      <v-flex class="sticky" sm3 xs12>
        <review-filter/>
      </v-flex>
      <v-flex offset-sm3 sm9 xs12>
        <review-approval-status-overview/>
        <br/>
        <review-bulk-buttons/>
        <v-alert
          :value="error"
          class="stickyAlert"
          color="error"
          icon="warning"
          dismissible
        >
          {{ $t('review.alerts.approvalError') }}
        </v-alert>
        <template v-if="reviews.length">
          <review-card
            v-for="review in reviews"
            :key="review.reviewId"
            :review="review"
            :selected="reviewIds.includes(review.reviewId)"
            :approval-status-filter="approvalStatusFilter"
          />
        </template>
        <div class="text-xs-center">
          <v-btn
            v-if="reviewsHasMore && reviews.length"
            :disabled="reviewsLoading"
            :loading="reviewsLoading"
            color="primary"
            large
            @click="fetchReviews"
          >
            {{ $t('review.filter.loadMore') }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-btn
      @click="toTop"
      v-scroll="onScroll"
      v-show="fab"
      color="primary"
      bottom
      fab
      fixed
      right
    >
      <v-icon>arrow_upward</v-icon>
    </v-btn>
  </v-container>
</template>

<style scoped>
  .stickyAlert {
    position: -webkit-sticky;
    position: fixed;
    top: 65px;
    left: 45%;
    z-index: 2;
  }

  .sticky {
    position: -webkit-sticky;
    position: fixed;
    width: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Review.vue